import { render } from "./UGCDungeonList.vue?vue&type=template&id=b719410e"
import script from "./UGCDungeonList.vue?vue&type=script&lang=js"
export * from "./UGCDungeonList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__